import { useRef, useState, useLayoutEffect } from 'react';

/**
 * Název položky široký přesně jako jeho text.
 *
 * Běžný `<input>` v pružném řádku roste přes celé volné místo, takže cokoli
 * za ním (výběr varianty) odletí až k pravému okraji — vypadá to, že patří
 * k tlačítkům, ne k názvu.
 *
 * Šířku proto měří skryté zrcadlo se stejným písmem: kolik text opravdu zabere.
 * Odhad přes `ch` jednotky nestačí — `ch` je šířka číslice, ale název je
 * proporcionální tučný text, takže u „01. Classic hamburger" zbyla vpravo
 * mezera na dva znaky a u samých „M" by se text naopak odroloval.
 *
 * `maxSirka` drží dlouhý název na uzdě, ať nevytlačí akce z řádku.
 */
export default function NazevInput({ value, onChange, placeholder, style, maxSirka = 460 }) {
    const zrcadlo = useRef(null);
    const [sirka, setSirka] = useState(0);

    // useLayoutEffect — šířka se propíše ve stejném snímku, jinak název při psaní probliká.
    useLayoutEffect(() => {
        if (zrcadlo.current) setSirka(zrcadlo.current.offsetWidth);
    }, [value, placeholder]);

    return (
        <>
            <input value={value} onChange={onChange} placeholder={placeholder}
                style={{ ...style, width: Math.min(sirka + 12, maxSirka), flex: '0 1 auto', minWidth: 40 }} />
            {/* Zrcadlo mimo tok i mimo čtečky — existuje jen kvůli změření textu */}
            <span ref={zrcadlo} aria-hidden="true"
                style={{
                    position: 'absolute', left: -9999, top: 0,
                    visibility: 'hidden', whiteSpace: 'pre', pointerEvents: 'none',
                    fontSize: style?.fontSize, fontWeight: style?.fontWeight, fontFamily: 'inherit',
                }}>
                {value || placeholder || ''}
            </span>
        </>
    );
}
